// extracted by mini-css-extract-plugin
export default {"form":"SigninForm_form__mo0f9","main-heading":"SigninForm_main-heading__R1LWa"};